<template>
  <div class="drop_wrap">
    <button
      class="more_btn hover_op"
      v-click-outside="hide"
      @click="show_drop = !show_drop"
    >
      <img src="@/assets/img/call_more_icon.svg" alt="" />
    </button>

    <div class="drop more_drop" :class="{ active: show_drop }">
      <div class="uers_wrap">
        <div class="avatar">{{ participant.name[0] }}</div>

        {{ participant.name }}
        <span v-if="participant.isLocal">(you)</span>
      </div>

      <div class="volume_meter_wrap">
        <img
          src="@/assets/img/volume_down_icon.svg"
          alt=""
          class="hover_op"
          @click="volume = parseFloat((volume - 0.1).toFixed(1))"
        />

        <vue-range-slider
          ref="slider"
          :min="0"
          :max="1"
          :step="0.1"
          :width="245"
          :tooltip="null"
          :dot="'disabled'"
          v-model="volume"
        ></vue-range-slider>

        <img
          src="@/assets/img/volume_up_icon.svg"
          alt=""
          class="hover_op"
          @click="volume = parseFloat((volume + 0.1).toFixed(1))"
        />
      </div>

      <button
        class="hover_op"
        @click="
          $store.commit('maximizeUserCallArea'), $emit('maiximazeThis'), hide()
        "
        v-if="!$store.state.user_maximized"
      >
        Maximize
      </button>

      <button
        class="hover_op"
        @click="
          $store.commit('minimizeUserCallArea'), $emit('minimizeThis'), hide()
        "
        v-if="$store.state.user_maximized"
      >
        Minimize
      </button>

      <button class="hover_op" @click="$emit('goFullscreen'), hide()">
        Fullscreen
      </button>

      <div class="divider"></div>

      <button
        class="hover_op"
        v-if="participant.video.state != 'off'"
        @click="ParticipantCameraOff(participant.userId), hide()"
      >
        Turn camera off
      </button>

      <button
        class="hover_op"
        v-if="participant.video.state === 'off'"
        @click="ParticipantCameraOn(participant.userId), hide()"
      >
        Turn camera on
      </button>

      <button
        class="hover_op"
        @click="muteParticipant(participant.userId), hide()"
        v-if="participant.audio.state != 'off'"
      >
        Turn microphone off
      </button>

      <button
        class="hover_op"
        @click="unmuteParticipant(participant.userId), hide()"
        v-if="participant.audio.state === 'off'"
      >
        Turn microphone on
      </button>

      <button class="hover_op" @click="eject(participant.userId), hide()">
        Kick
      </button>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";

export default {
  name: "TileOptionDropDown",

  components: { VueRangeSlider },

  emits: ["maiximazeThis", "minimizeThis", "goFullscreen"],

  props: ["participant"],

  data() {
    return {
      show_drop: false,
      volume: 0.5,
    };
  },

  watch: {
    volume: function () {
      if (this.volume > 8) return;
      else if (this.volume > 1) {
        this.volume = 1;
      } else if (this.volume < 0) {
        this.volume = 0;
      }

      this.$emit("VolumeChange", this.volume);
    },
  },

  methods: {
    hide() {
      this.show_drop = false;
    },

    muteParticipant(id) {
      this.$store.dispatch("muteParticipant", id);
    },

    unmuteParticipant(id) {
      this.$store.dispatch("unmuteParticipant", id);
    },

    ParticipantCameraOn(id) {
      this.$store.dispatch("ParticipantCameraOn", id);
    },

    ParticipantCameraOff(id) {
      this.$store.dispatch("ParticipantCameraOff", id);
    },

    eject(id) {
      this.$store.dispatch("eject", id);
    },

    hide() {
      this.show_drop = false;
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">
.drop_wrap {
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  & > * {
    pointer-events: all;
  }
}

.drop.more_drop {
  top: 56px;
  right: 16px;
  width: 422px;
  max-width: calc(100% - 32px);

  @media all and (max-width: 815px) {
  }

  @media all and (max-width: 767px) {
    left: 0;
    right: 0;
    top: 32px;
    max-width: 100%;
    z-index: 10;
  }

  .uers_wrap {
    display: flex;
    align-items: center;
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 32px;
    margin-left: 32px;
    margin-right: 32px;

    @media all and (max-width: 815px) {
      margin-bottom: 16px;
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  .volume_meter_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    margin-left: 32px;
    margin-right: 32px;

    @media all and (max-width: 815px) {
      margin-bottom: 16px;
      margin-left: 16px;
      margin-right: 16px;
    }

    img {
      height: 24px;
      cursor: pointer;
    }
  }

  .avatar {
    margin-right: 32px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    @media all and (max-width: 767px) {
      margin-right: 16px;
    }
  }

  & > button {
    @media all and (max-width: 815px) {
      width: 100%;
    }
  }

  .divider {
    height: 1px;
    background-color: #000;
    opacity: 0.16;
    margin: 16px 32px;

    @media all and (max-width: 815px) {
      margin: 16px;
    }
  }
}

.vue-range-slider {
  margin-left: 32px;
  margin-right: 32px;

  &.slider-component .slider .slider-process {
    background-color: #000;
  }
}
</style>
